import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NotificationService, GridDataSource, LoaderService, CONSTANT, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { Iempresa, Empresa } from '../shared/empresa.model';
import { EmpresaService } from '../shared/empresa.service';

@Component({
    selector: 'app-empresa-edit',
    templateUrl: 'empresa-edit.component.html'
})
export class EmpresaEditComponent implements OnInit {
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @Input() data: any;
    @Input() titlePage: string;

    formGrupEditEmpresa: FormGroup;
    buttonGroup: any;
    officeName: string;
    nomofficeMaxLength: number;
    descriptionMaxLength: number;
    nomEmpresaPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
    msgErrorActualizar: string;
    msgErrorGet: string;
    obligatorioMsg: string;
    msgErrorGetEmpresas: string;
    empresa: Iempresa;
    rucMaxLength: number = 12;
    dniMaxLength: number = 8;

    constructor(
        private loaderService: LoaderService,
        private notificationService: NotificationService,
        private errorService: ErrorService,
        private empresaService: EmpresaService,
        public fb: FormBuilder) { }

    ngOnInit() {
        this.buttonGroup = [
            { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
        ];
        this.msgErrorActualizar = 'Error al actualizar datos';
        this.msgErrorGet = 'Error al obtener datos';
        this.empresa = new Empresa(0, "", "", "", "", "", "", true, "", "", "", "", "", null, "");
        this.setValuesFormBuilder();
        this.obtenerEmpresa(this.data.empresa.ID);

    }

    private setValuesFormBuilder() {
        this.formGrupEditEmpresa = this.fb.group({
            Name: [this.empresa.Name, Validators.compose([Validators.required])],
            Direccion: [this.empresa.Direccion, Validators.compose([Validators.required])],
            RUC: [this.empresa.RUC, Validators.compose([Validators.required])],
            razonSocial: [this.empresa.RazonSocial, Validators.compose([Validators.required])],
            Agent: [this.empresa.Agent, Validators.compose([Validators.required])],
            documento: [this.empresa.Dni, Validators.compose([Validators.required])],
            nombreCorto: [this.empresa.nombreCorto, Validators.compose([Validators.required])],
            status: [this.empresa.status],
        });
    }

    formGrupEditEmpresaSubmit(event) {
        if (this.formGrupEditEmpresa.invalid)
            return;
        this.empresa.ID = this.data.empresa.ID;
        this.empresa.Name = event.value.Name;
        this.empresa.Direccion = event.value.Direccion;
        this.empresa.RUC = event.value.RUC;
        this.empresa.RazonSocial = event.value.razonSocial;
        this.empresa.Agent = event.value.Agent;
        this.empresa.status = event.value.status;
        this.empresa.Dni = event.value.documento;
        this.empresa.nombreCorto = event.value.nombreCorto;
        this.actualizarEmpresa(this.empresa);
    }

    changeEvent(empresa: Iempresa) {
        this.data.empresa = empresa;
        this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    }


    private actualizarEmpresa(empresa: Iempresa) {
        this.loaderService.show();
        this.empresaService.actualizarEmpresa(empresa)
            .subscribe(res => {
                this.changeEvent(empresa);
            },
                error => {
                    this.notificationService.error(this.msgErrorActualizar);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }

    private obtenerEmpresa(empresaID: number): void {
        this.loaderService.show();
        this.empresaService.obtenerEmpresa(empresaID)
            .subscribe(res => {
                this.empresa = res;
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.setValuesFormBuilder();
                    this.loaderService.hide();
                });
    }
    public onlyDecimalNumberKey() {

    }
}
